import homePageComponentsApiFactory from '../../modules/homePageComponents/homePageComponentsApi';

/* Utils */
import {
  generateDefaultAsyncWatcher,
  generateDefaultAsyncSaga,
} from '../core/reduxUtils';

/* Actions */
import {
  getHomePageComponentsActionCreators,
  getCmsHomePageComponentsActionCreators,
  getHomepageComponentsWithBannerListActionCreators,
} from '../actions/homePageComponentsActions';

function homePageComponentsSagasFactory({storefrontApiClient}) {
  const homePageComponentsApi = homePageComponentsApiFactory(storefrontApiClient);

  const getHomePageComponents = generateDefaultAsyncSaga(
    homePageComponentsApi.getHomePageComponents,
    getHomePageComponentsActionCreators,
    payload => [
      payload.params,
    ]
  );

  const getCmsHomePageComponentsSagas = generateDefaultAsyncSaga(
    homePageComponentsApi.getCmsHomePageComponents,
    getCmsHomePageComponentsActionCreators,
    payload => [
      payload.params,
    ]
  );

  const getHomepageComponentsWithBannerListSagas = generateDefaultAsyncSaga(
    homePageComponentsApi.getHomepageComponentsWithBannerList,
    getHomepageComponentsWithBannerListActionCreators,
    payload => [
      payload.homepageComponents,
      payload.params,
      payload.userId,
      payload.anonymousId,
      payload.isPersonalizationEnabled,
      payload.isLocationAwareAvailable,
      payload.isCustomerInfoEnabled,
    ]
  );

  const watchGetHomePageComponents = generateDefaultAsyncWatcher(
    'GET_HOME_PAGE_COMPONENTS',
    getHomePageComponents
  );

  const watchGetCmsHomePageComponents = generateDefaultAsyncWatcher(
    'GET_CMS_HOME_PAGE_COMPONENTS',
    getCmsHomePageComponentsSagas,
  );

  const watchGetHomepageComponentsWithBannerList = generateDefaultAsyncWatcher(
    'GET_HOMEPAGE_COMPONENTS_WITH_BANNER_LIST',
    getHomepageComponentsWithBannerListSagas,
  );

  const homePageComponentsSagas = [
    watchGetHomePageComponents(),
    watchGetCmsHomePageComponents(),
    watchGetHomepageComponentsWithBannerList(),
  ];

  return homePageComponentsSagas;
}

export default homePageComponentsSagasFactory;
